<div class="container-md pt-lg !min-h-[calc(100%-147px)] flex flex-col gap-xl font-size-setting-{{settings.textSize()}}">
  @for (message of chatService.messageArray(); track message.answer) {
    <app-chat-question [content]="message.question" />
    <div>
      <app-chat-answer [message]="message" />
      @if (message.status === 'done') {
        <app-chat-answer-feedback [message]="message" />
      }
    </div>
  }
</div>

<div class="chat-input">
  <app-chat-input (submitted)="chatService.ask($event)" />
  <app-landing-disclaimer />
</div>
